module.exports = __webpack_public_path__ + "e9ab56291cbac7436ec0ad0e02d1df4b.png";